<template>
  <div>
    <v-form @submit.prevent="submitResponse">
      <p class="mb-3">
        Dehydrozingerone (DHZ) is the crossed aldol product you made this week. Identify the
        different functional groups present on the molecule.
      </p>

      <p class="mb-4 pl-6">
        <v-img style="max-width: 400px" :src="$publicAsset('/img/assignments/UCIrvine/DHZ.png')" />
      </p>

      <p v-for="option in options" :key="option.value" class="mb-0 mt-0">
        <v-checkbox v-model="inputs.input1" :value="option.value" class="ml-6 mb-n4 mt-0">
          <template v-slot:label>
            <stemble-latex :content="option.text" />
          </template>
        </v-checkbox>
      </p>
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import StembleLatex from '../StembleLatex.vue';

export default {
  name: 'ChemUCI51PLFS1Q2',
  components: {
    StembleLatex,
  },
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        input1: [],
      },
      options: [
        {text: 'Alkene', value: 'a'},
        {text: 'Amide', value: 'b'},
        {text: 'Carboxylic Acid', value: 'c'},
        {text: 'Alkyne', value: 'd'},
        {text: 'Ketone', value: 'e'},
        {text: 'Ester', value: 'f'},
        {text: 'Aldehyde', value: 'g'},
        {text: 'Alcohol', value: 'h'},
        {text: 'Ether', value: 'i'},
      ],
    };
  },
};
</script>
<style scoped></style>
